if(document.querySelectorAll(".temp-product").length > 0){
let feqinput = document.querySelectorAll(".block_product-frequently-info-inner-checkbox input");
feqinput.forEach((event) => {
	event.addEventListener("click", (e) => {
		let target = e.target;
		let adttrId = target.getAttribute("id");
		let array = [];
		let checkValues = document.querySelectorAll("input[name='product-frequently']:checked");
		checkValues.forEach((e) => {
			array.push(e.getAttribute("data-price"));
		})
        array.push()
		let output = ""
		let sum = 0;
		let checkd = document.querySelectorAll("input[name='product-frequently']:checked").length;
        output += ``   
		for (let i = 1; i <= array.length; i++) {
		sum += Number(array[i - 1]);
          
		if (i == 1) {
		  output += `
           <div class="block_product-frequently-info-bottom-price-main">
             <div class="block_product-frequently-info-bottom-price">
               <p class="block_product-frequently-info-bottom-add-title">${i} item</p>
               <p class="block_product-frequently-info-bottom-add-price">${Shopify.formatMoney(array[i - 1])}</p>
             </div>
            </div>
           `
			} else {
			output += `
             <div class="block_product-frequently-info-bottom-price-main">
             <div class="block_product-frequently-info-bottom-price">
               <p class="block_product-frequently-info-bottom-add-title">${i} Add-ons</p>
               <p class="block_product-frequently-info-bottom-add-price">${Shopify.formatMoney(array[i - 1])}</p>
             </div>
            </div>
            `
		  }
		}
		if (array.length >= 2) {          
          document.querySelector(".block_product-frequently-info-bottom").classList.remove("hidden")
			output += `
             <div class="block_product-frequently-info-bottom-price-main">
             <div class="block_product-frequently-info-bottom-price">
               <p class="block_product-frequently-info-bottom-add-title">Total</p>
               <p class="block_product-frequently-info-bottom-add-price">${Shopify.formatMoney(sum)}</p>
             </div>
            </div>
            `
		}else{
          document.querySelector(".block_product-frequently-info-bottom").classList.add("hidden")
        }
        let totalPrice = 0;
        document.querySelectorAll(".block_product-frequently-info-inner").forEach((e) => {
          totalPrice +=   Number(e.getAttribute("data-proprice"));
        })     
      console.log("sum" , Shopify.formatMoney(sum))
        let mainProprice = document.querySelector('.block_product-frequently-info-button').getAttribute("data-mainprice");
        document.querySelector('.block_product-frequently-btn-price').innerHTML = Shopify.formatMoney(sum);
        document.querySelector('.block_product-frequently-btn-count').innerHTML = checkd ;
		    document.querySelector('.block_product-frequently-info-bottom-inner-price').innerHTML = output;
	})
})

// ==============add-to-cart=====================

 document.querySelector(".block_product-frequently-info-button").addEventListener("click", (e) => {
    e.preventDefault(), e.stopImmediatePropagation();
    let sample_product_atc_array = [];
     document.querySelectorAll("input[name='product-frequently']:checked").forEach( (event) => {
         sample_product_atc_array.push({
          id: event.getAttribute("value"),
          quantity: 1
        });
     }) 
    let sample_product_atc_formData = {items:sample_product_atc_array, sections_url:window.location.pathname, sections:document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id)};
    $sample_atc_submit_event(sample_product_atc_formData);
  });
}
